import React, { CSSProperties, FC, useCallback } from 'react';
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import Button from "../../UiLib/Button/Button";
import AbsolutePosition from "../../UiLib/AbsolutePosition/AbsolutePosition";
import { zPositionWindows } from "../../UiLib/zPositionWindows";
import "./ConfirmModal.css"

interface IConfirmModalProps {
    headText: string;
    bodyText?: string;
    confirmText: string;
    cancelText: string;
    confirmImg?: string;
    cancelImg?: string;
    callBack: (check: boolean) => void;
    style?: CSSProperties;
    className?: string;
}

const ConfirmModal: FC<IConfirmModalProps> = ({
    className,
    style,
    headText,
    bodyText,
    confirmText,
    cancelText,
    confirmImg,
    cancelImg,
    callBack
}) => {
    const onConfirm = useCallback(() => {
        callBack(true);
    }, [callBack]);

    const onCloseConfirm = useCallback(() => {
        callBack(false);
    }, [callBack]);

    const confirmButtonStyle: CSSProperties = {
        backgroundColor: "var(--ui-color-absolute-position-button-confirm)",
        padding: "18px",
        borderRadius: "5px",
        marginRight: "10px"
    };

    const cancelButtonStyle: CSSProperties = {
        backgroundColor: "var(--ui-color-absolute-position-button-cansel)",
        padding: "18px",
        borderRadius: "5px"
    };

    return (
        <AbsolutePosition className={className} zIndex={zPositionWindows.confirmModal}>
            <WidgetContainer style={style}>
                <div className="modal__confirm--block">
                    <div className="modal__confirm--block__head">
                        <h2>{headText}</h2>
                    </div>
                    {bodyText && (
                        <div className="modal__confirm--block__body">
                            <p>{bodyText}</p>
                        </div>
                    )}
                </div>
                <div className="modal__confirm--block__buttons">
                    <Button
                        // textColor="--ui-color-absolute-position-button-confirm-text"
                        style={confirmButtonStyle}
                        text={confirmText}
                        image={confirmImg}
                        callBack={onConfirm}
                    />
                    <Button
                        // textColor="--ui-color-absolute-position-button-cansel-text"
                        style={cancelButtonStyle}
                        text={cancelText}
                        image={cancelImg}
                        callBack={onCloseConfirm}
                    />
                </div>
            </WidgetContainer>
        </AbsolutePosition>
    );
};

export default React.memo(ConfirmModal);